import { render, staticRenderFns } from "./barExamine.vue?vue&type=template&id=474f5f1c&scoped=true&"
import script from "./barExamine.vue?vue&type=script&lang=js&"
export * from "./barExamine.vue?vue&type=script&lang=js&"
import style0 from "./barExamine.vue?vue&type=style&index=0&id=474f5f1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f5f1c",
  null
  
)

export default component.exports